module.exports = __webpack_public_path__ + "img/image-01.2732d06a.jpg";